import * as React from "react";

const ProSVG = () => {
  return (
    <svg
      width="45"
      height="25"
      viewBox="0 0 45 25"
      fill="none"
    >
      <rect
        y="0.8125"
        width="45"
        height="24"
        rx="5"
        fill="url(#paint0_linear_1537_4662)"
      />
      <path
        d="M15.248 11.1005C15.248 11.6978 15.104 12.2578 14.816 12.7805C14.5387 13.3032 14.096 13.7245 13.488 14.0445C12.8907 14.3645 12.1333 14.5245 11.216 14.5245H9.344V18.8125H7.104V7.6445H11.216C12.08 7.6445 12.816 7.79383 13.424 8.0925C14.032 8.39117 14.4853 8.80183 14.784 9.3245C15.0933 9.84717 15.248 10.4392 15.248 11.1005ZM11.12 12.7165C11.7387 12.7165 12.1973 12.5778 12.496 12.3005C12.7947 12.0125 12.944 11.6125 12.944 11.1005C12.944 10.0125 12.336 9.4685 11.12 9.4685H9.344V12.7165H11.12ZM22.6984 18.8125L20.2344 14.4605H19.1784V18.8125H16.9384V7.6445H21.1304C21.9944 7.6445 22.7304 7.79917 23.3384 8.1085C23.9464 8.40717 24.3997 8.81783 24.6984 9.3405C25.0077 9.8525 25.1624 10.4285 25.1624 11.0685C25.1624 11.8045 24.949 12.4712 24.5224 13.0685C24.0957 13.6552 23.461 14.0605 22.6184 14.2845L25.2904 18.8125H22.6984ZM19.1784 12.7805H21.0504C21.6584 12.7805 22.1117 12.6365 22.4104 12.3485C22.709 12.0498 22.8584 11.6392 22.8584 11.1165C22.8584 10.6045 22.709 10.2098 22.4104 9.9325C22.1117 9.6445 21.6584 9.5005 21.0504 9.5005H19.1784V12.7805ZM32.4724 18.9245C31.427 18.9245 30.467 18.6792 29.5924 18.1885C28.7177 17.6978 28.0244 17.0205 27.5124 16.1565C27.0004 15.2818 26.7444 14.2952 26.7444 13.1965C26.7444 12.1085 27.0004 11.1325 27.5124 10.2685C28.0244 9.39383 28.7177 8.71117 29.5924 8.2205C30.467 7.72983 31.427 7.4845 32.4724 7.4845C33.5284 7.4845 34.4884 7.72983 35.3524 8.2205C36.227 8.71117 36.915 9.39383 37.4164 10.2685C37.9284 11.1325 38.1844 12.1085 38.1844 13.1965C38.1844 14.2952 37.9284 15.2818 37.4164 16.1565C36.915 17.0205 36.227 17.6978 35.3524 18.1885C34.4777 18.6792 33.5177 18.9245 32.4724 18.9245ZM32.4724 16.9245C33.1444 16.9245 33.7364 16.7752 34.2484 16.4765C34.7604 16.1672 35.1604 15.7298 35.4484 15.1645C35.7364 14.5992 35.8804 13.9432 35.8804 13.1965C35.8804 12.4498 35.7364 11.7992 35.4484 11.2445C35.1604 10.6792 34.7604 10.2472 34.2484 9.9485C33.7364 9.64983 33.1444 9.5005 32.4724 9.5005C31.8004 9.5005 31.203 9.64983 30.6804 9.9485C30.1684 10.2472 29.7684 10.6792 29.4804 11.2445C29.1924 11.7992 29.0484 12.4498 29.0484 13.1965C29.0484 13.9432 29.1924 14.5992 29.4804 15.1645C29.7684 15.7298 30.1684 16.1672 30.6804 16.4765C31.203 16.7752 31.8004 16.9245 32.4724 16.9245Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1537_4662"
          x1="45"
          y1="12.8125"
          x2="-3.27021e-07"
          y2="12.8125"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E5637F" />
          <stop offset="1" stop-color="#604EA0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default ProSVG;
